import React, {useState, useEffect} from "react";
import moment from "moment";
import { useParams } from "react-router-dom";

import {CampaignReportAPI, CampaignLeadsAPI} from "./../../../API/Sales/CampaignAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import Paginate from "../../../utils/Pagination";


const CampaignReport = () =>{

    const {campaignid} = useParams();

    const [freshleadcount, setFreshLeadCount] = useState(0);
    const [warmleadcount, setWarmLeadCount] = useState(0);
    const [todayfollowupcount, setTodayFollowupCount] = useState(0);
    const [pendingfollowupcount, setPendingFollowupCount] = useState(0);

    /*const [totalleadcount, setTotalLeadCount] = useState(0);
    const [assignedleadcount, setAssignedLeadCount] = useState(0);
    const [noanswerleadcount, setNoAnswerLeadCount] = useState(0);
    const [todayleadcount, setTodayLeadCount] = useState(0);
    const [calledleadcount, setCalledLeadCount] = useState(0);
    const [convertedleadcount, setConvertedLeadCount] = useState(0);
    const [notinterestleadcount, setNotInterestLeadCount] = useState(0);
    const [callbackleadcount, setCallBackLeadCount] = useState(0);
    const [nextyearleadcount, setNextYearLeadCount] = useState(0);*/
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [leadloading, setLeadLoading] = useState(true);
    const [campaignname, setCampaignName] = useState("");

    const perpagedata = 20;

    useEffect(() =>{
        console.log('Sales dahboard');

        CampaignReportAPI(setFreshLeadCount, setWarmLeadCount, setTodayFollowupCount, setPendingFollowupCount, setLoading, campaignid, setCampaignName);
        
    }, []);

    useEffect(() =>{

        CampaignLeadsAPI(setLeads, campaignid, currentPage, perpagedata, setPageCount, setLeadLoading);
        
    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);
        
        //console.log('Current Page====' + currentPage);
    }


    return(
    <div className="main-wrapper">

        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="page-header">
                            <div className="row align-items-center ">
                                <div className="col-md-4">
                                    <h3 className="page-title">{campaignname} Report</h3>
                                </div>
                                <div className="col-md-8 float-end ms-auto">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{freshleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Fresh Leads</div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{todayfollowupcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Today Follow Ups</div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{warmleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Warm Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{pendingfollowupcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Pending Follow Ups</div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    
                    {/*<div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{totalleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Total Leads</div>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{noanswerleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Contacted Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{todayleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Dead Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{calledleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Cold Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{convertedleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Attempt to Contact Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{notinterestleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Enrolled Leads</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="card card-border-bottom">
                            <div className="card-body p-3 d-flex align-items-center mx-auto">                            	
                                <div>
                                    <div className="fs-25 fw-semibold widget-text text-center">{nextyearleadcount}</div>
                                    <div className="text-body-secondary fw-semibold widget-heading">Enrolled %</div>
                                </div>
                            </div>
                        </div>
                    </div>*/}					
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card w-100">
                            <div className="card-header border-0 pb-0">
                                <h4><i className="ti ti-grip-vertical me-1"></i>Campaign Leads</h4>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive custom-table">
                                    <table className="table" id="">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Contact</th>
                                                <th>Location</th>
                                                <th>Program</th>
                                                <th>Institute</th>
                                                <th>Lead Status</th>
                                                <th>Caller Name</th>
                                                <th>Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {leadloading ?
                                            <tr>
                                                <td colSpan="7">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (leads && leads.length > 0  ? 
                                                ( leads.map(lead => 
                                                    (
                                            
                                                        <tr key={lead.id}>
                                                            <td>{lead.name}</td>
                                                            <td>{lead.email}</td>
                                                            <td>{lead.contact}</td>
                                                            <td>{lead.location}</td>
                                                            <td>{lead.program}</td>
                                                            <td>{lead.institute}</td>
                                                            <td>
                                                                {lead.leadstatus ?
                                                                    <span class="badge badge-tag badge-purple-light">{lead.leadstatus}</span>
                                                                :
                                                                    <span>-</span>
                                                                }
                                                            </td>
                                                            <td>{lead.callername}</td>
                                                            <td>{moment(lead.created_at).format('DD-MMM-YYYY')}</td>
                                                            
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="7">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                
                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="pagination-section mt-3">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default CampaignReport;